import { render, staticRenderFns } from "./ModalAddProduct.vue?vue&type=template&id=42a82c45&scoped=true"
import script from "./ModalAddProduct.vue?vue&type=script&lang=js"
export * from "./ModalAddProduct.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProduct.vue?vue&type=style&index=0&id=42a82c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a82c45",
  null
  
)

export default component.exports